// Tab1.js
import { useTheme as useAppTheme } from "../../contexts/ThemeContext";
import React from 'react';
import { useState } from "react";
import MoreVertIcon from '@mui/icons-material/MoreVert';
import Autocomplete from "@mui/material/Autocomplete";
import useMediaQuery from "@mui/material/useMediaQuery";
import { styled } from "@mui/material/styles";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Tooltip from '@mui/material/Tooltip';
import Table from "@mui/material/Table";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import { useEffect, useRef } from "react";
import { Card, Button, Grid, TextField, FormControl, InputLabel, Select, MenuItem, FormHelperText, Paper, TablePagination } from "@mui/material";
import Drawer from "@mui/material/Drawer";
import { ButtonGroup, Skeleton } from "@mui/material";
import DateFilter from "./DateFilter.jsx";
import MemberAvatar from './MemberAvatar';
import IconButton from "@mui/material/IconButton";
import EmailIcon from '@mui/icons-material/Email';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import AppToast from '../../components/Toast/AppToast';
import MenuIcon from "@mui/icons-material/Menu";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Menu from '@mui/material/Menu';
import CircularProgress from "@mui/material/CircularProgress";
import json2mq from "json2mq";
import { useNavigate } from "react-router-dom";
import {
  MemberExpireByDate,
  MainPackagDueDateAutocomplete
} from "../Apihelper/DueUserApi.js";

// Styled Components
const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
    fontWeight: 'bold',
    borderBottom: 'none',
    padding: '8px 10px',
    whiteSpace: 'normal',
    [theme.breakpoints.down('sm')]: {
      padding: '8px 12px',
      fontSize: '0.875rem',
    },
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 12,
    padding: '8px 10px',
    whiteSpace: 'normal',
    [theme.breakpoints.down('sm')]: {
      padding: '8px 12px',
      fontSize: '0.813rem',
    },
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: '#f9f9f9',
  },
  '&:hover': {
    backgroundColor: 'rgba(31, 122, 84, 0.08)',
    cursor: 'pointer',
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));

const Tab2 = (props) => {
    const { window1 } = props;
    const navigate = useNavigate();
    const { colors: appColors } = useAppTheme();
    const [mobileOpen, setMobileOpen] = React.useState(false);
    const [loading, setLoading] = useState(false);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [totalCount, setTotalCount] = useState(0);
    const dateRef = useRef();
    const [age, setAge] = React.useState('');
    const [options, setOptions] = useState([]);
    const [fetchdatarow, setetchdatarow] = useState([]); 
    const [datelist, setDatelist] = useState([]);
    const [fromDate, setFromDate] = useState("");
    const [todate, settodate] = useState("");
    const [openToast, setOpenToast] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState('');
    const [snackbarSeverity, setSnackbarSeverity] = useState('success');
    const handleSnackbarOpen = (message, severity) => { setSnackbarMessage(message); setSnackbarSeverity(severity); setOpenToast(true); };
    const handleToastClose = () => setOpenToast(false);
    const handleChange = (event) => {
      setAge(event.target.value);
    };
  
    const handleCardPress = async (member_id) => {
      try {
        navigate("/memberdetails", {
          state: {
            id: member_id,
            random_no: Math.random(),
          },
        });
      } catch (error) {
        console.error("Error:", error);
      }
    };

    const handleSendWhatsApp = async (memberId) => {
      try {
        const userData = JSON.parse(localStorage.getItem('userdata') || '{}');
        const res = await fetch(`${window.constants.api_url}/due-whatsapp/payment-due`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${userData.token}` },
          body: JSON.stringify({ member_id: memberId }),
        });
        const data = await res.json();
        handleSnackbarOpen(data.message, data.code == 200 ? 'success' : 'error');
      } catch (e) {
        handleSnackbarOpen('Failed to send WhatsApp', 'error');
      }
    };

    const handleSendEmail = async (memberId) => {
      try {
        const userData = JSON.parse(localStorage.getItem('userdata') || '{}');
        const res = await fetch(`${window.constants.api_url}/due-email/payment-due`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${userData.token}` },
          body: JSON.stringify({ member_id: memberId }),
        });
        const data = await res.json();
        handleSnackbarOpen(data.message, data.code == 200 ? 'success' : 'error');
      } catch (e) {
        handleSnackbarOpen('Failed to send email', 'error');
      }
    };

    const mediaQueryVar = useMediaQuery(
      json2mq({
        minWidth: 600,
      })
    );
  
    function createData(name, calories, fat, carbs, protein) {
      return { name, calories, fat, carbs, protein };
    }
  
    const rows = [
      createData('MTTMG231202205353', 'Jyotiranjan Sahoo', '7609942076', 'sahoorinku63@gmail.com', 4.0),
      createData('MTTMG231202205353', 'Jyotiranjan Sahoo', '7609942076', 'sahoorinku63@gmail.com', 4.3),
      createData('MTTMG231202205353', 'Jyotiranjan Sahoo', '7609942076', 'sahoorinku63@gmail.com', 6.0),
      createData('MTTMG231202205353', 'Jyotiranjan Sahoo', '7609942076', 'sahoorinku63@gmail.com', 4.3),
      createData('MTTMG231202205353', 'Jyotiranjan Sahoo', '7609942076', 'sahoorinku63@gmail.com', 3.9),
    ];
    
      const ITEM_HEIGHT = 48;
      const [anchorEl, setAnchorEl] = React.useState(null);
      const open = Boolean(anchorEl);
      const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
      };
      const handleClose = () => {
        setAnchorEl(null);
      };
      useEffect(() => {
        const storedData = localStorage.getItem("userdata");
        if (!storedData) {
          // User is not logged in, no need to redirect
          navigate('/');
        }
        
      }, []);
      const fetchData = async (value = '', newPage = 0, newRowsPerPage = rowsPerPage) => {
        setLoading(true);
        try {
            const userData = localStorage.getItem("userdata");
            const userDataObj = JSON.parse(userData);
            const userToken = userDataObj.token;
            const userId = userDataObj.id;
            const searchText = value;
            const limit = newRowsPerPage;
            const index = newPage * newRowsPerPage;
            const res = await MemberExpireByDate(userToken, userId, searchText, limit, index, datelist,
              fromDate,
              todate);

            if (res.code == "200") {
                const data = res.data;
                setetchdatarow(data);
                console.log(data);
                setLoading(false);
                const rawTotal = res.total_count ?? res.recordsTotal ?? res.recordsFiltered ?? res.total ?? null;
                if (rawTotal !== null) {
                  setTotalCount(rawTotal);
                } else {
                  setTotalCount(
                    data.length < newRowsPerPage
                      ? newPage * newRowsPerPage + data.length
                      : (newPage + 1) * newRowsPerPage + 1
                  );
                }
            } else {
            }
        } catch (error) {
            console.error(error);
        }
    };
    const handleChangePage = (event, newPage) => {
      setPage(newPage);
      fetchData('', newPage, rowsPerPage);
    };
    const handleChangeRowsPerPage = (event) => {
      const newRowsPerPage = parseInt(event.target.value, 10);
      setRowsPerPage(newRowsPerPage);
      setPage(0);
      fetchData('', 0, newRowsPerPage);
    };
    useEffect(() => {
     
      fetchData();
  }, []);
  const handleSearchChange = (event, value) => {
    const searchText = value || ''; // If value is undefined or empty, set searchText to empty string
    setPage(0);
    fetchData(searchText, 0, rowsPerPage);
  };
  const handleInputChange = async (value) => {
    if (value.length >= 3) {
    try {
        const userData = localStorage.getItem("userdata");
        const userDataObj = JSON.parse(userData);
        const userToken = userDataObj.token;
        const userId = userDataObj.id; // Assuming you have a userId in userdata
        const searchText = value; // Example search text
      
        const res = await MainPackagDueDateAutocomplete(userToken, userId, searchText);
  
        if (res.code == "200") {
            const names = res.data.map(item => item.search_text);
            setOptions(names);
        } else {
            handleSnackbarOpen(res.message, 'error');
            //  console.error(error); // Handle error
        }
    } catch (error) {
        console.error(error);
        // Handle errors
    }
  }
  };


  const handleApplydatecustom = async ({ fromDateval, toDateval, value = '' }) => {
    settodate(toDateval);
    setFromDate(fromDateval);
    setLoading(true);
    setPage(0);
    try {
      const userData = localStorage.getItem("userdata");
      const userDataObj = JSON.parse(userData);
      const userToken = userDataObj.token;
      const userId = userDataObj.id;
      const searchText = value;
      const limit = rowsPerPage;
      const index = 0;

      const data = await MemberExpireByDate(
        userToken,
        userId,
        searchText,
        limit,
        index,
        datelist,
        fromDateval,
        toDateval,
      );
      if (data.code == "200") {
        setetchdatarow(data.data);
        setLoading(false);
        const rawTotal = data.total_count ?? data.recordsTotal ?? data.recordsFiltered ?? data.total ?? null;
        if (rawTotal !== null) {
          setTotalCount(rawTotal);
        } else {
          setTotalCount(
            data.data.length < rowsPerPage
              ? data.data.length
              : rowsPerPage + 1
          );
        }
      } else {
        setetchdatarow([]);
        setTotalCount(0);
      }
    } catch (error) {
      console.error("Error:", error);
    }
    // Handle the selected value in the parent page
  };
  const handleApplydate = async (selectedValue, value = '') => {
    setDatelist(selectedValue);
    setLoading(true);
    setPage(0);
    try {
      const userData = localStorage.getItem("userdata");
      const userDataObj = JSON.parse(userData);
      const userToken = userDataObj.token;
      const userId = userDataObj.id;
      const searchText = value;
      const limit = rowsPerPage;
      const index = 0;
      const data = await MemberExpireByDate(
        userToken,
        userId,
        searchText,
        limit,
        index,
        selectedValue,
        "",
        "",
      );
      if (data.code == "200") {
        setLoading(false);
        setetchdatarow(data.data);
        const rawTotal = data.total_count ?? data.recordsTotal ?? data.recordsFiltered ?? data.total ?? null;
        if (rawTotal !== null) {
          setTotalCount(rawTotal);
        } else {
          setTotalCount(
            data.data.length < rowsPerPage
              ? data.data.length
              : rowsPerPage + 1
          );
        }
      } else {
        setetchdatarow([]);
        setTotalCount(0);
      }
    } catch (error) {
      console.error("Error:", error);
    }
    // Handle the selected value in the parent page
  };
  return (
    <div>
    <Box sx={{ 
      display: 'flex', 
      flexDirection: { xs: 'column', sm: 'row' },
      gap: 2,
      mb: 2
    }}>
      <Box sx={{ flex: 1 }}>
                <Autocomplete
                  freeSolo
                  options={options}
          onInputChange={(event, value) => handleInputChange(value)}
                  onChange={(event, value) => handleSearchChange(event, value)}
                  renderInput={(params) => (
                    <TextField
              {...params}
                      size="small"
              fullWidth
              label="Search"
                      InputProps={{
                        ...params.InputProps,
                        type: 'search',
                      }}
                  sx={{
                '& .MuiOutlinedInput-root': {
                  backgroundColor: '#fff',
                }
                  }}
            />
          )}
                />
              </Box>
              <Box>
        <FormControl>
          <DateFilter
            ref={dateRef}
                      onApplycustomdate={handleApplydatecustom}
                      onApply={handleApplydate}
                  />
                </FormControl>
              </Box>
            </Box>

              <TableContainer
      component={Paper}
      sx={{ boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)', borderRadius: '8px', overflow: 'auto', mb: 2 }}
    >
      <Table size="small">
        <TableHead>
          <TableRow>
            <StyledTableCell sx={{ width: 36 }}>#</StyledTableCell>
            <StyledTableCell>MEMBER</StyledTableCell>
            <StyledTableCell sx={{ display: { xs: 'none', sm: 'table-cell' } }}>PHONE</StyledTableCell>
            <StyledTableCell sx={{ display: { xs: 'none', md: 'table-cell' } }}>EMAIL</StyledTableCell>
            <StyledTableCell>PACKAGE</StyledTableCell>
            <StyledTableCell align="center">RENEWAL DATE</StyledTableCell>
            <StyledTableCell align="center">ACTIONS</StyledTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {loading ? Array.from({ length: rowsPerPage }).map((_, i) => (
            <TableRow key={i}>
              <TableCell><Skeleton width={20} /></TableCell>
              <TableCell>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <Skeleton variant="circular" width={34} height={34} />
                  <Box><Skeleton width={110} /><Skeleton width={80} height={10} /></Box>
                </Box>
              </TableCell>
              <TableCell sx={{ display: { xs: 'none', sm: 'table-cell' } }}><Skeleton width={90} /></TableCell>
              <TableCell sx={{ display: { xs: 'none', md: 'table-cell' } }}><Skeleton width={140} /></TableCell>
              <TableCell><Skeleton width={70} /></TableCell>
              <TableCell><Skeleton width={80} /></TableCell>
              <TableCell><Skeleton width={60} /></TableCell>
            </TableRow>
          )) : fetchdatarow.map((row, index) => (
            <StyledTableRow key={row.id}>
              <StyledTableCell sx={{ color: '#9ca3af', fontSize: 11 }}>{page * rowsPerPage + index + 1}</StyledTableCell>
              <StyledTableCell>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <MemberAvatar image={row.image} name={row.name} size={34} />
                  <Box>
                    <Typography onClick={() => handleCardPress(row.member_id)} sx={{ fontSize: 13, fontWeight: 600, color: appColors.leaf, cursor: 'pointer', '&:hover': { textDecoration: 'underline' } }}>
                      {row.name}
                    </Typography>
                    <Typography sx={{ fontSize: 11, color: '#9ca3af' }}>{row.membership_number}</Typography>
                  </Box>
                </Box>
              </StyledTableCell>
              <StyledTableCell sx={{ fontSize: 13, display: { xs: 'none', sm: 'table-cell' } }}>{row.phone}</StyledTableCell>
              <StyledTableCell sx={{ fontSize: 12, color: '#6b7280', display: { xs: 'none', md: 'table-cell' } }}>{row.email}</StyledTableCell>
              <StyledTableCell sx={{ fontSize: 12 }}>{row.package_name}</StyledTableCell>
              <StyledTableCell align="center" sx={{ fontSize: 12 }}>{row.end_date}</StyledTableCell>
              <StyledTableCell align="center">
                <Box sx={{ display: 'flex', gap: 0.5, justifyContent: 'center' }}>
                  <Tooltip title="Send WhatsApp">
                    <IconButton size="small" sx={{ color: '#25d366', '&:hover': { bgcolor: 'rgba(37,211,102,0.08)' } }} onClick={() => handleSendWhatsApp(row.member_id)}>
                      <WhatsAppIcon sx={{ fontSize: 17 }} />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Send Email">
                    <IconButton size="small" sx={{ color: appColors.leaf, '&:hover': { bgcolor: 'rgba(31,122,84,0.08)' } }} onClick={() => handleSendEmail(row.member_id)}>
                      <EmailIcon sx={{ fontSize: 17 }} />
                    </IconButton>
                  </Tooltip>
                </Box>
              </StyledTableCell>
            </StyledTableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>

            <TablePagination
  component="div"
  count={totalCount}
  page={page}
  onPageChange={handleChangePage}
  rowsPerPage={rowsPerPage}
  rowsPerPageOptions={[10, 20, 50]}
  onRowsPerPageChange={handleChangeRowsPerPage}
  showFirstButton
  showLastButton
  sx={{ '& .MuiTablePagination-actions': { mr: 8 } }}
  labelDisplayedRows={({ page: p, count }) =>
    `Page ${p + 1} of ${Math.ceil(count / rowsPerPage)}  |  Total: ${count} records`
  }
/>
    <AppToast open={openToast} message={snackbarMessage} severity={snackbarSeverity} onClose={handleToastClose} />
    </div>
  );
}

export default Tab2;
